'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The button with selected value that toggles the popover.
 * It doesn't pass element to the ref callback if written as a stateless function.
 */
var SelectButton = function (_PureComponent) {
    _inherits(SelectButton, _PureComponent);

    function SelectButton() {
        _classCallCheck(this, SelectButton);

        return _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).apply(this, arguments));
    }

    _createClass(SelectButton, [{
        key: 'render',
        // eslint-disable-line
        value: function render() {
            var _props = this.props,
                label = _props.label,
                major = _props.major,
                disabled = _props.disabled,
                onClick = _props.onClick;

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('ui-btn', 'sb-select__button', {
                        'ui-btn_primary': major,
                        'ui-btn_primary--disabled': major && disabled,
                        'ui-btn--disabled': !major && disabled
                    }),
                    onClick: disabled ? null : onClick
                },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    label
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'down', size: 'Medium' })
            );
        }
    }]);

    return SelectButton;
}(_react.PureComponent);

SelectButton.propTypes = {
    /**
     * This is the label to be displayed.
     * It could be a string or a node to render.
     */
    label: _react.PropTypes.node.isRequired,
    /**
     * Applies major button styling.
     */
    major: _react.PropTypes.bool.isRequired,
    /**
     * Disables the button.
     */
    disabled: _react.PropTypes.bool,
    /**
     * The 'click' event handler.
     */
    onClick: _react.PropTypes.func.isRequired
};

exports.default = SelectButton;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectButton.js
// module id = 2778
// module chunks = 0